import { client } from './client'
import Keyword from '../models/keyword'

export default {
  index (query) {
    return client.get('/keywords', {
      params: query
    })
  },
  show (id) {
    return client.get('/keywords/' + id)
      .then((response) => {
        return new Keyword(response.data.data)
      })
  },
  store (data) {
    return client.post('/keywords', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/keywords/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/keywords', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let keyword = new Keyword()
    keyword.keyword = data
    return client.get('/keywords', {
      params: {
        filter: JSON.stringify(keyword),
        limit: 100,
        orderBy: 'keyword'
      }
    })
  },
  delete (id) {
    return client.delete('/keywords/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/keywords.js